import React, { useEffect, useRef, useState } from "react";
import { CircularProgress, Dialog, DialogContent } from "@material-ui/core";
import styled from "styled-components";
import Flex from "../../../components/_styles/Flex";
import Select, { components } from "react-select";
import { ReactComponent as CloseIcon } from "../../../assets/cancel-outline.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  showAlert,
  UPDATE_CHART_ORDER_REQUEST,
  UpdateChartOrder,
  UpdateChartVisiblity,
} from "../../../actions/radminUploads";
import { getSavedCustomChartData } from "../../../actions/radminCustomChartData";
import { bottom, height } from "styled-system";
import verticalLine from "../../../assets/verticalLine.svg";

export const FilterContainer = styled(Flex)`
  width: 900px;
  height: 38px;
  justify-content: space-around;
  align-items: center;
  top: 0%;
  bottom: 30%;
  background: #ffffff;
  border: 1px solid #c2ccd9;
  box-sizing: border-box;
  border-radius: 5px;
  cursor: pointer;
  @media (max-width: 768px) {
    margin-top: 15px;
  }
`;

const DialogContentStyled = styled(DialogContent)`
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  MuiDialog-container {
    height: unset;
  }
  overflow: hidden;
`;

const StyledLabel = styled.label`
  margin-right: 10px;
  font-weight: 700;
  font-size: 14px;
  color: #6d6e6e;
`;

export const Card = styled(Flex)`
  min-width: max-content;
  flex-direction: column;
  align-items: flex-start;
  media (max-width: 657px) {
    margin-left: 78px;
  }
`;

const FilterMenuTitle = styled.div`
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 30px;
  color: #0c2945;
`;

const ModalHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25.5px 30px;
  border-bottom: 1.5px solid #eff3f5;
`;

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
  align-items: center;
`;

const Loader2 = styled(CircularProgress)`
  width: 30px !important;
  height: 30px !important;
`;

const DropdownItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  font-size: 14px;
  padding: 6px 30px;
  opacity: ${(props) => (props.isDragging ? 0.5 : 1)};
  transform: ${(props) => (props.isDragging ? "translateY(-5px)" : "none")};
  transition: transform 0.2s ease;
  &:last-child {
    margin-bottom: 0;
  }
  &:hover {
    background-color: #80808014;
  }
`;

const Option = (props) => {
  return (
    <>
      <components.Option {...props}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              position: "relative",
              width: "100%",
            }}
          >
            <span style={{ marginRight: 5 }}>
              <input
                type="radio"
                checked={props.isSelected}
                onChange={() => null}
                style={{ cursor: "pointer" }}
              />{" "}
            </span>
            <label
              style={{
                cursor: "pointer",
                marginBottom: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  width: "220px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "inline-block",
                }}
              >
                {props.label}
              </span>
              {props.data?.isPublished && !props.data?.isEditable && (
                <span
                  style={{
                    background: "#c3c3c3",
                    borderRadius: "8px",
                    color: "grey",
                    padding: "2px 10px",
                    fontSize: "10px",
                    fontWeight: 600,
                    position: "absolute",
                    top: "50%",
                    right: 0,
                    transform: "translateY(-50%)",
                  }}
                >
                  Published
                </span>
              )}
            </label>
          </div>
        </div>
      </components.Option>
    </>
  );
};

const EditableChartModal = (props) => {
  const {
    showEditableModal,
    setShowEditableModal,
    setSelectedChart,
    handleChartSelect,
  } = props;
  const topRef = useRef(null);

  const chart = useSelector((state) => state?.radAdmin?.chart);
  const [customCharts, setCustomCharts] = useState([]);
  const [selectedChartData, setSelectedChartData] = useState(null);
  const dispatch = useDispatch();
  const permission = useSelector((state) => state.auth.user.permission_level);
  const rolePermissions = useSelector((state) => state.auth.user.permissions);
  const updatePermission = rolePermissions
    ?.find((itm) => itm.name === "Overview")
    ?.permissions.find(
      (itm) => itm.codename === "change_overview"
    )?.is_authorized;

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("text/plain", index.toString());
  };

  const handleDragOver = (e) => {
    if ((permission && updatePermission) || !permission) {
      e.preventDefault();
    } else {
      dispatch(
        showAlert(
          "danger",
          "Error",
          `You don't have permission to edit displayed charts`
        )
      );
    }
  };

  const handleDrop = (e, index) => {
    const draggedIndex = parseInt(e.dataTransfer.getData("text/plain"), 10);
    const updatedColumns = [...chart?.data];
    const [draggedColumn] = updatedColumns.splice(draggedIndex, 1);
    updatedColumns.splice(index, 0, draggedColumn);
    dispatch({ type: UPDATE_CHART_ORDER_REQUEST })
    dispatch(UpdateChartOrder(updatedColumns));
  };

  const chartOptions =
    customCharts.length > 0 &&
    customCharts?.map((chart) => ({
      value: chart?.id,
      label: chart.title,
      created: chart?.created,
      isEditable: chart?.is_editable,
      isPublished: chart?.is_published,
    }));

  const updatedCustomChartOption =
    chartOptions &&
    chartOptions?.length > 0 &&
    chartOptions
      ?.filter(
        (item1) =>
          !chart?.data?.some(
            (item2) =>
              item2?.source === "custom_chart" && item2.id === item1.value
          )
      )
      .map(({ created, label, value, isEditable, isPublished }) => ({
        created,
        label,
        value,
        isEditable,
        isPublished,
      }));

  const updateVisibility = async (data) => {
    if(data?.source === "custom_chart") {
      await dispatch(UpdateChartVisiblity(data, chart?.data));

    } else {
      await dispatch(UpdateChartVisiblity(data));
    }
  };

  useEffect(() => {
    dispatch(getSavedCustomChartData(1)).then((res) => {
      if (res) {
        setCustomCharts(res.results);
      }
    });
  }, []);

  return (
    <FilterContainer showMenu={showEditableModal}>
      {showEditableModal && (
        <Dialog
          open={showEditableModal}
          aria-labelledby="form-dialog-title"
          maxWidth="xl"
          style={{
            backdropFilter: "blur(5px)",
            top: 0,
          }}
          onClose={() => setShowEditableModal(false)}
        >
          <DialogContentStyled style={{ padding: "0px", height: 600 }}>
            <Card>
              <ModalHeader>
                <FilterMenuTitle>Edit Displayed Charts </FilterMenuTitle>
                <CloseIcon
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowEditableModal(false)}
                />
              </ModalHeader>

              <div
                style={{
                  width: "500px",
                  height: "510px",
                }}
                ref={topRef}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-around",
                    padding: "6px 30px 30px 30px",
                  }}
                >
                  <StyledLabel htmlFor="customChartDropdown">
                    CUSTOM CHARTS
                  </StyledLabel>
                  {
                    updatedCustomChartOption && updatedCustomChartOption?.length > 0 &&
                    <div style={{ minWidth: "350px" }}>
                    <Select
                      components={{ Option }}
                      id="customChartDropdown"
                      options={
                        updatedCustomChartOption && updatedCustomChartOption
                      }
                      value={selectedChartData}
                      onChange={(selectedOption) =>
                        handleChartSelect(selectedOption)
                      }
                      isClearable={true}
                    />
                  </div>
                  }
                  
                </div>
                <div style={{ overflowY: "auto", height: 400 }}>
                  {chart?.isLoading  ? (
                    <LoaderContainer>
                      <Loader2 />
                    </LoaderContainer>
                  ) : (
                    chart?.data?.map((data, index) => (
                      <DropdownItem
                        key={data?.id}
                        onDragStart={(e) => {
                          if ((permission && updatePermission) || !permission) {
                            handleDragStart(e, index);
                          } else {
                            dispatch(
                              showAlert(
                                "danger",
                                "Error",
                                `You don't have permission to edit displayed charts`
                              )
                            );
                          }
                        }}
                        onDragOver={handleDragOver}
                        onDrop={(e) => {
                          if ((permission && updatePermission) || !permission) {
                            handleDrop(e, index);
                          } else {
                            dispatch(
                              showAlert(
                                "danger",
                                "Error",
                                `You don't have permission to edit displayed charts`
                              )
                            );
                          }
                        }}
                        draggable
                        isHidden={!data?.is_active}
                      >
                        <div style={{ display: "flex", textAlign: "left" }}>
                          <img
                            style={{
                              cursor: "pointer",
                              marginRight: "10px",
                              marginBottom: "1rem",
                              width: "20px",
                            }}
                            src={verticalLine}
                            alt="icon"
                          />
                          <p>
                            {data?.title}{" "}
                            <span style={{ whiteSpace: "pre-line" }}>
                              {data?.description}
                            </span>{" "}
                          </p>
                        </div>
                        <p
                          style={{
                            color: "#00aeef",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            if (
                              (permission && updatePermission) ||
                              !permission
                            ) {
                                updateVisibility(data);
                            } else {
                              dispatch(
                                showAlert(
                                  "danger",
                                  "Error",
                                  `You don't have permission to edit displayed charts`
                                )
                              );
                            }
                          }}
                        >
                          {data?.is_active ? "Hide" : "Show"}
                        </p>
                      </DropdownItem>
                    ))
                  )}
                </div>
              </div>
            </Card>
          </DialogContentStyled>
        </Dialog>
      )}
    </FilterContainer>
  );
};

export default EditableChartModal;
